import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext.tsx';
import { CiSquareQuestion } from 'react-icons/ci';
import '../../styles/Navbar.css';

interface NavbarProps {
	onMenuClick: () => void;
}

const Navbar: React.FC<NavbarProps> = ({ onMenuClick }) => {
	const { user, signOut } = useAuth();
	const navigate = useNavigate();
	const location = useLocation();
	const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

	useEffect(() => {
		const handleResize = () => {
			setIsMobile(window.innerWidth <= 768);
		};

		window.addEventListener('resize', handleResize);
		return () => window.removeEventListener('resize', handleResize);
	}, []);

	const handleSignOut = async () => {
		try {
			await signOut();
			navigate('/login');
		} catch (error) {
			console.error('Error signing out:', error);
		}
	};

	const handleTitleClick = () => {
		if (location.pathname !== '/') {
			navigate('/');
		}
	};

	const handleGuideClick = () => {
		navigate('/guide');
	};

	return (
		<nav className='navbar'>
			<div className='navbar-left'>
				{/* {!isMobile && (
          <button className="menu-button" onClick={onMenuClick}>
            Menu
          </button>
        )} */}
				<h1 onClick={handleTitleClick} style={{ cursor: 'pointer' }}>
					Rental Management
				</h1>
			</div>

			<div className='navbar-right'>
				<CiSquareQuestion
					className='navbar-help-btn'
					title='Help & Guide'
					onClick={handleGuideClick}
				/>
				<button className='btn-secondary' onClick={handleSignOut}>
					Sign Out
				</button>
			</div>
		</nav>
	);
};

export default Navbar;
